<template>
  <div class="main-container">
    <div class="unavailable-items-modal">
      <div class="unavailable-items-modal__icon" @click="closeModal">
        <svg
          class="unavailable-items-modal__image svg-inline--fa"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path
            fill="currentColor"
            stroke="currentColor"
            stroke-linecap="square"
            stroke-width="2"
            d="M1.368 1.368l13.264 13.264m0-13.264L1.368 14.632"
          />
        </svg>
      </div>
      <div class="unavailable-items-modal__body">
        <div class="unavailable-items-modal__notifier">
          <app-notifier class="m-t-20" :type="'failed'">
            <div>
              Sorry! Following items are not available for the selected pickup time.
            </div>
            <strong>
              <span v-if="!selectedTime">Now</span>
              <span v-if="selectedTime">
                {{ parsedDate(selectedTime, venueTimezone) }}
              </span>
            </strong>
          </app-notifier>
        </div>
        <div class="unavailable-items-modal__items">
          <h5 class="m-b-10">Items not available at the selected time</h5>
          <VendorMenuItemDefault
            v-for="(item, index) in unavailableItems"
            :key="`${item.id}-${index}`"
            :menu-item="item"
            unavailable
            hide-price
          >
          </VendorMenuItemDefault>
        </div>
        <div class="d-flex flex-space-between confirmation-buttons">
          <app-button :text="'Select different time'" :aria-label="'Select different time'" :handler="toSelectionScreen" outlined>
          </app-button>
          <app-button :text="'Continue'" :aria-label="'Continue'" :handler="handleContinue"> </app-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { parsedDate } from "@/utils";

export default {
  name: "UnavailableItemsModal",
  props: {
    closeModal: Function,
    onContinue: Function,
    selectedTime: String,
    toSelectionScreen: Function
  },
  data() {
    return {
      unavailableItems: []
    };
  },
  mounted() {
    this.unavailableItems = this.getUnavailableItems(this.selectedTime);
  },
  methods: {
    removeUnavailableItemsFromCart() {
      const itemsToRemove = this.getUnavailableItems(this.selectedTime);
      while (itemsToRemove.length) {
        this.removeItem({ index: itemsToRemove.pop().index });
      }
    },
    handleContinue() {
      this.removeUnavailableItemsFromCart();
      this.onContinue();
    },
    parsedDate,
    ...mapActions({
      removeItem: "cart/removeItemFromShoppingCart"
    })
  },
  computed: {
    ...mapGetters({
      venueTimezone: "venue/getVenueTimezone",
      getUnavailableItems: "cart/getUnavailableCartItems"
    })
  }
};
</script>
<style lang="scss" scoped>
.dark {
  a:link {
    color: #ffffff;
  }
  a:visited {
    color: #ffffff;
  }
}

.main-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.unavailable-items-modal {
  display: flex;
  justify-content: left;
  flex-flow: column;
  align-items: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  font-family: $theme2__fontFamilyPrimary;
  color: $text-color;
  padding: 30px;
  @include respond-to-mobile {
    padding: 10px 20px;
  }

  &__icon {
    align-self: flex-end;
    cursor: pointer;
    padding: 15px 5px 10px;
  }

  &__items {
    width: calc(100% - 80px);
    margin-left: 40px;
    margin-right: 40px;
    margin-top: 40px;
    margin-bottom: 25px;

    @include respond-to-mobile {
      margin-left: 27px;
      margin-right: 27px;
      width: calc(100% - 54px);
    }
  }

  &__body {
    display: block;
    font-size: 20px;
    font-weight: 100;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.65;
    letter-spacing: normal;
    width: 100%;
    margin-bottom: 45px;

    .menu-item {
      pointer-events: none;
    }

    @include respond-to-mobile {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
    }

    .confirmation-buttons {
      button:nth-of-type(1) {
        margin-right: 10px;
      }
    }
  }

  &__header {
    margin-top: 50px;
  }
  &__strong {
    font-weight: bold;
  }
  &__notifier {
    display: block;
    width: 100%;
  }
}
</style>
